import { render, staticRenderFns } from "./global-config.vue?vue&type=template&id=2efbb1c2&scoped=true"
import script from "./global-config.vue?vue&type=script&lang=js"
export * from "./global-config.vue?vue&type=script&lang=js"
import style0 from "./global-config.vue?vue&type=style&index=0&id=2efbb1c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efbb1c2",
  null
  
)

export default component.exports